import ListMedicalFacility from '@components/MedicalFacility/ListMedicalFacility';
import SlideMedicalFacility from '@components/MedicalFacility/SlideMedicalFacility';
import MedialFacilityNav from '@components/MedicalFacility/MedialFacilityNav';
import { BookingProvider } from '@contexts/BookingContext';
import {NextSeo} from 'next-seo';
import AppConfigService from '@services/app-config.service';
import MedicalFacility from '@services/medical-facility.service';
import {getAutoSEO} from '@helper/seo/seo';

/**
 * Trang danh sách cơ sở y tế
 * Hiển thị danh sách các bệnh viện và cơ sở y tế
 */
export default function MedialFacility(props) {
    const {seoPage} = props;
    
    return (
        <BookingProvider>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
                {/* Hero section với banner */}
                <SlideMedicalFacility />
                
                {/* Navigation menu */}
                <MedialFacilityNav />
                
                {/* Danh sách cơ sở y tế */}
                <ListMedicalFacility />
            </div>
        </BookingProvider>
    );
}

// Tên trang cho SEO
MedialFacility.PageName = 'MEDICAL-FACILITY';

MedialFacility.getInitialProps = async (context) => {
    try {
        const ctx = context || {};
        const appConfigService = new AppConfigService(ctx);
        const seoConfig = await appConfigService.getAppConfig({page: 'SEO'});
        
        // Fetch data thực tế để tạo SEO tự động
        let pageData = {};
        try {
            const medicalFacilityService = new MedicalFacility(ctx);
            const facilitiesResponse = await medicalFacilityService.getMedicalFacilityHome({
                locale: ctx.locale || 'vn'
            });
            const facilities = facilitiesResponse?.data || facilitiesResponse || [];
            pageData.totalFacilities = Array.isArray(facilities) ? facilities.length : 0;
        } catch (err) {
            console.error('Failed to fetch medical facilities data for SEO:', err);
        }
        
        // Sử dụng getAutoSEO để tạo SEO tự động từ data
        let seoPage = getAutoSEO('MEDICAL-FACILITY', seoConfig, pageData);
        
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || 'https://tnh.com.vn';
        seoPage.canonical = `${webUrl}/co-so-y-te`;
        if (seoPage.openGraph) {
            seoPage.openGraph.url = `${webUrl}/co-so-y-te`;
        }
        
        return {seoPage};
    } catch (error) {
        console.error('Failed to fetch SEO for medical facility page:', error);
        return {seoPage: null};
    }
};
